import React from "react";
import ArrowRight from "../../assets/arrow-right.svg?react";
import classnames from "classnames";
import { ButtonVariant } from "../../types/button";

interface ButtonProps {
  text: string;
  variant?: ButtonVariant;
  className?: string;
  onClick: (evt?: React.MouseEvent<HTMLElement>) => void;
}

const getClassByVariant = (variant: ButtonVariant) => {
  switch (variant) {
    case "main":
      return "px-6 bg-primary text-md text-white justify-center outline-none hover:bg-primaryBlue hover:border-primaryBlue hover:text-white hover:outline-none";
    case "secondary":
    case "link-primary":
      return "px-6 border-2 border-primary bg-transparent text-primary justify-center outline-none hover:text-primaryBlue hover:border-primaryBlue hover:outline-none";
    case "link-primary-reverse":
      return "px-6 border-2 border-white bg-transparent text-white justify-center outline-none hover:border-primaryBlue hover:text-primaryBlue hover:border-2 hover:outline-none";
    case "link-secondary":
      return "text-primary hover:text-primaryBlue border-0 outline-none hover:border-none hover:outline-none";
    case "text":
      return "text-primary hover:text-primaryBlue justify-center";
    case "link-secondary-reverse":
      return "text-white border-none justify-center hover:text-primaryBlue hover:border-none hover:outline-none";
    case "main-reverse":
      return "px-6 bg-white text-primary hover:bg-primaryBlue hover:text-white justify-center border-white outline-white border-white hover:outline-primaryBlue hover:border-primaryBlue";
    default:
      return "bg-primary text-white justify-center";
  }
};

const typesWithIcons = [
  "link-primary",
  "link-secondary",
  "link-primary-reverse",
  "link-secondary-reverse",
];

export const Button: React.FC<ButtonProps> = ({
  variant = "main",
  text,
  className,
  onClick,
}) => {
  const shouldUseIcon = typesWithIcons.includes(variant);

  return (
    <button
      className={classnames(
        getClassByVariant(variant),
        "leading-9 rounded flex items-center group",
        className
      )}
      onClick={onClick}
    >
      {text}
      {shouldUseIcon && (
        <span className="ml-2 group-hover:translate-x-2 transition-all ease-out">
          <ArrowRight />
        </span>
      )}
    </button>
  );
};

export default Button;
